import * as z from 'zod'

const rollSchema = z.object({
  rollNumber: z.number().nullable().optional(),
  lengthValue: z.number().nullable().optional(),
  lengthUnit: z.number().nullable().optional(),
  weight: z.number().nullable().optional(),
  id: z.string().optional().nullable()
})

export const returnFromSupplierSchema = z.object({
  id: z.string().optional().nullable(),
  finishingSupplierId: z.string().optional().nullable(),
  finishingQualityId: z.string().nullable().optional(),
  purchaseOrderReference: z.string().optional().nullable(),
  weight: z.number().optional().nullable(),
  lengthValue: z.any().optional().nullable(),
  lengthUnit: z.any().optional().nullable(),
  totalPercentageWeightLostOrGained: z.number().optional().nullable(),
  dateReturned: z.union([z.string(), z.date()]).optional().nullable(),
  rolls: z.array(rollSchema),
  notes: z.string().optional().nullable(),
  lastEditedBy: z.string().optional().nullable()
})